import {
  Button,
  Flex,
  Header,
  HeaderTitleTile,
  Loader,
  Tabs,
} from '@components';

import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import { getCustomerDetailsTabs } from './NomineeCustomer.const';
import {
  Container,
  StyledContentContainer,
  StyledHeaderContainer,
} from './NomineeCustomer.styles';
import { useNomineeCustomersQuery } from '@features/api/nomineeCustomerSlice';
import { useUserQuery } from '@features/api/userSlice';
import { NewInvestmentPanel } from '@components/NewInvestmentPanel/NewInvestmentPanel';
import { useMediaQueries } from '@utils/mediaQueries/mediaQueries';

const NomineeCustomer = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { sm: isMobile } = useMediaQueries();
  const { tabId, customerId } = useParams();
  const [selectedTabId, setSelectedTabId] =
    useState<string | number | undefined>(tabId);

  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

  const { data: user, isLoading: isLoadingUser } = useUserQuery();
  const { data: nomineeCustomers, isLoading: isLoadingCustomers } =
    useNomineeCustomersQuery();

  const customer = nomineeCustomers?.find((x) => x.id === customerId);

  const customerDetailsTabs = getCustomerDetailsTabs(
    navigate,
    customer,
    customer?.id
  );

  useEffect(() => {
    if (!tabId && customerDetailsTabs?.[0]?.id) {
      setSelectedTabId(customerDetailsTabs[0].id);
      navigate(`/${customerDetailsTabs[0].id}`, { replace: true });
    }
  }, [navigate, customerDetailsTabs, tabId]);

  useEffect(() => {
    if (tabId) setSelectedTabId(tabId);
  }, [tabId]);

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setSelectedTabId(newValue);
  };

  const handleCloseSidePanel = () => {
    setIsSidePanelOpen(false);
  };

  const handleOpenSidePanel = () => {
    setIsSidePanelOpen(true);
  };

  if (isLoadingCustomers || isLoadingUser) return <Loader isLoading />;
  return (
    <Container>
      <StyledHeaderContainer>
        <Header
          user={user}
          title={{
            name: intl.formatMessage({ id: 'menu.crm' }),
            to: '/crm',
          }}
        />
        <HeaderTitleTile
          title={{
            name: intl.formatMessage({
              id: 'crm.customer.allCustomers',
            }),
            to: '/crm',
          }}
          subtitles={[{ name: `${customer?.firstName} ${customer?.lastName}` }]}
        />
      </StyledHeaderContainer>
      <StyledContentContainer>
        <Flex flex={1} mt={8}>
          <Tabs
            variant='scrollable'
            allowScrollButtonsMobile
            tabItem={customerDetailsTabs}
            onChange={handleChange}
            value={selectedTabId}
            tabRightComponent={() =>
              selectedTabId === 'transactions' ? (
                <Button onClick={handleOpenSidePanel}>
                  <FormattedMessage
                    id={
                      !isMobile
                        ? 'crm.investments.createNewInvestment'
                        : 'crm.investments.newInvestment'
                    }
                  />
                </Button>
              ) : (
                <></>
              )
            }
          />
        </Flex>
      </StyledContentContainer>
      <NewInvestmentPanel
        isOpen={isSidePanelOpen}
        onClose={handleCloseSidePanel}
        customer={customer}
      />
    </Container>
  );
};

export default NomineeCustomer;
